<template>
    <footer id="contact-us" class="footer">
        <div class="footer-left">
            <img
                src="../assets/img/logo-color-width.webp"
                class="logo"
                alt="Peak link logo"
                height="100%"
                width="100%"
            />
            <p class="footer-text">{{ $t('footer.disc') }}</p>

            <ul class="social-links">
                <li>
                    <a
                        class="social facebook"
                        :href="$store.state.contact_data.facebook"
                        target="_blank"
                    >
                        <b-icon icon="facebook"></b-icon>
                    </a>
                </li>
                <li>
                    <a
                        class="social whatsapp"
                        :href="$store.state.contact_data.whatsapp_link"
                        target="_blank"
                    >
                        <b-icon icon="whatsapp"></b-icon>
                    </a>
                </li>
                <li>
                    <a
                        class="social instagram"
                        :href="$store.state.contact_data.insta"
                        target="_blank"
                    >
                        <b-icon icon="instagram"></b-icon>
                    </a>
                </li>
            </ul>
        </div>
        <div class="footer-right">
            <div class="column">
                <div class="header">{{ $t('footer.explore') }}</div>
                <ul class="list">
                    <li
                        class="list-item"
                        v-for="(item, index) in $t('navbar.title')"
                        :key="index"
                        v-scroll-to="{
                        el: '#' + item.scroll,
                        offset: -66,
                        force: true,
                    }"
                    >{{ item.text }}</li>
                </ul>
            </div>
            <div class="column">
                <div class="header">{{ $t('footer.get_in_touch') }}</div>
                <ul class="list-contact">
                    <li>
                        <a
                            class="row list-contact-item"
                            :href="$store.state.contact_data.location_link"
                            target="_blank"
                        >
                            <b-icon class="icon-contact" icon="geo-alt-fill" aria-hidden="true"></b-icon>
                            <p>{{ $store.state.contact_data.location }}</p>
                        </a>
                    </li>
                    <li>
                        <a
                            class="row list-contact-item"
                            :href="$store.state.contact_data.email_link"
                        >
                            <b-icon class="icon-contact" icon="envelope-fill" aria-hidden="true"></b-icon>
                            <p>{{ $store.state.contact_data.email }}</p>
                        </a>
                    </li>
                    <li>
                        <a
                            class="row list-contact-item"
                            :href="$store.state.contact_data.phone_link"
                        >
                            <b-icon class="icon-contact" icon="telephone-fill" aria-hidden="true"></b-icon>
                            <p style="direction: ltr">+963 {{ $store.state.contact_data.phone }}</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>

export default {
    name: "Footer",
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
        getContact() {
            this.axios.get(this.$store.state.url + "contact-us")
                .then(res => {
                    this.$store.state.contact_data = res.data.list
                    this.initContact(this.$store.state.contact_data)
                    this.$store.state.get_contact = true
                });
        },
        initContact(data) {
            data.forEach(element => {
                if (element.name == 'Whatsapp') {
                    this.$store.state.contact_data.whatsapp = element.value
                    this.$store.state.contact_data.whatsapp_link = "https://wa.me/00963" + this.$store.state.contact_data.whatsapp
                }
                if (element.name == 'Phone') {
                    this.$store.state.contact_data.phone = element.value
                    this.$store.state.contact_data.phone_link = "tel:+963" + this.$store.state.contact_data.phone
                }
                if (element.name == "Facebook")
                    this.$store.state.contact_data.facebook = element.value
                if (element.name == 'Instagram')
                    this.$store.state.contact_data.insta = element.value
                if (element.name == "Email") {
                    this.$store.state.contact_data.email = element.value
                    this.$store.state.contact_data.email_link = "mailto:" + this.$store.state.contact_data.email
                }
                if (element.name == "Location")
                    this.$store.state.contact_data.location = element.value
                if (element.name == "Location Link")
                    this.$store.state.contact_data.location_link = element.value
                if (element.name == 'Linkedin')
                    this.$store.state.contact_data.linkedin = element.value
            });
        }
    },
    mounted() {
        this.getContact()
    }
};

</script>


<style lang="scss">
.footer {
    background: linear-gradient(
        270deg,
        rgba(144, 255, 122, 0.267),
        rgba(35, 75, 255, 0.171)
    );
    display: grid;
    column-gap: 300px;
    position: relative;
    overflow: hidden;
    z-index: -1;
}

@media (min-width: 992px) {
    .footer {
        grid-template-columns: 40fr 60fr;
        padding: 60px 100px;
    }

    .footer .footer-right {
        grid-template-columns: 30% 60%;
    }
}

@media (max-width: 991px) {
    .footer {
        grid-template-columns: repeat(1, 1fr);
        padding: 60px;
    }

    .footer .footer-right {
        grid-template-columns: repeat(1, 1fr);
        justify-content: center;
    }

    .footer .column {
        margin-top: 50px;
    }
}

.footer .footer-image-right {
    top: 0;
    left: 0;
    position: absolute;
    z-index: 0;
    height: 100%;
}

.footer .footer-image-left {
    bottom: -10px;
    right: 0;
    position: absolute;
    z-index: 0;
    height: 100%;
}

.footer .footer-text {
    color: gray;
    font-size: 14px;
    margin-bottom: 5px;
}

.footer .footer-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    top: -60px;
    position: inherit;
}

.footer .logo {
    width: 200px;
    height: auto;
}

.footer .social-links {
    margin-top: 20px;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    z-index: 100;
    padding: 0px;
}

.footer .footer-right {
    z-index: 3;
    display: grid;
    // grid-template-columns: .7fr .7fr 1fr;
    grid-column-gap: 6rem;
    column-gap: 6rem;
}

.footer .footer-right .column {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    text-align: justify;
}

.footer .footer-right .header {
    color: var(--main-blue);
    font-weight: bold;
    font-size: 20px;
}

.footer .footer-right .list {
    list-style: none;
    color: gray;
    font-size: 15px;
    padding: 0px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
}

.footer .footer-right .list-contact {
    list-style: none;
    color: gray;
    font-size: 15px;
    padding: 0px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
}

html:lang(en) .footer .footer-right .list-item:hover {
    color: var(--main-blue);
    margin-left: 10px;
    transition: all 0.5s;
}

html:lang(ar) .footer .footer-right .list-item:hover {
    color: var(--main-blue);
    margin-right: 10px;
    transition: all 0.5s;
}

.footer .footer-right .list-item {
    cursor: pointer;
    transition: all 0.5s;
}

.footer .icon-contact {
    padding: 3px 10px;
    margin-right: 15px;
    // color: var(--main-blue);
}

.footer .list-contact-item {
    transition: all 0.5s;
    color: #808080;
}

html:lang(en) .footer .list-contact-item:hover {
    color: var(--main-blue);
    margin-left: -5px;
    transition: all 0.5s;
    cursor: pointer;
}

html:lang(ar) .footer .list-contact-item:hover {
    color: var(--main-blue);
    margin-right: -5px;
    transition: all 0.5s;
    cursor: pointer;
}

.footer .social {
    border-radius: 50%;
    padding: 8px;
    font-size: 22px;
    color: var(--main-yellow);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 100;
    transition: transform 1s;
}

.footer .facebook {
    border: 1px solid var(--main-blue);
    color: var(--main-blue);
    transition: all 0.5s;
}

.footer .facebook:hover {
    color: white;
    background: var(--main-blue);
    transition: all 0.5s;
}

.footer .whatsapp {
    border: 1px solid var(--main-green);
    color: var(--main-green);
    transition: all 0.5s;
}

.footer .whatsapp:hover {
    color: white;
    background: var(--main-green);
    transition: all 0.5s;
}

.footer .instagram {
    border: 1px solid var(--main-yellow);
    color: var(--main-yellow);
    transition: all 0.5s;
}

.footer .instagram:hover {
    color: white;
    background: var(--main-yellow);
    transition: all 0.5s;
}
</style>